import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DealsListPage from './pages/DealsListPage';
import DealPage from './pages/DealPage';
import SOWReport from './pages/SOWReport';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                   element={<DealsListPage />} />
        <Route path="/deals/:id"          element={<DealPage />} />
        <Route path="/deals/:id/report"   element={<SOWReport />} />
        <Route path="*"                   element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
